import React from 'react';

import { PERMISSION } from 'src/features/auth/types';
import { LIST_MEMBERSHIPS_RESOURCE } from 'src/features/membership/api/useListMemberships';
import { ACTIVE_STAY_RESOURCE } from 'src/features/stay/api/useGetActiveStay';
import { ACTIVE_STAY_PERIOD_RESOURCE } from 'src/features/stay/api/useGetActiveStayPeriod';
import { LIST_ACTIVE_STAY_PERIODS_RESOURCE } from 'src/features/stay/api/useListActiveStayPeriods';
import { LIST_ACTIVE_STAYS_RESOURCE } from 'src/features/stay/api/useListActiveStays';
import WSContext, { WebSocketGroup } from 'src/features/visitor/context/WSContext';
import { WebSocketEvent, WebSocketEventMessages } from 'src/features/visitor/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { queryClient } from 'src/lib/react-query';

export default function MembershipTypeChangesListener() {
    const { subscribe, unsubscribe } = React.useContext(WSContext);
    const canSeeMemberships = useHasPermissions(
        [PERMISSION.ACCESS_MEMBERSHIPS, PERMISSION.ACCESS_MEMBERSHIP_TYPES, PERMISSION.ACCESS_ACTIVE_STAYS],
        true,
    );

    const handleWebSocket = React.useCallback((event: WebSocketEvent) => {
        if (event.message !== WebSocketEventMessages.MEMBERSHIP_TYPE_CHANGES_PROPAGATED) return;

        void queryClient.invalidateQueries({ queryKey: [LIST_MEMBERSHIPS_RESOURCE] });
        void queryClient.invalidateQueries({ queryKey: [LIST_ACTIVE_STAYS_RESOURCE] });
        void queryClient.invalidateQueries({ queryKey: [LIST_ACTIVE_STAY_PERIODS_RESOURCE] });
        void queryClient.invalidateQueries({ queryKey: [ACTIVE_STAY_PERIOD_RESOURCE] });
        void queryClient.invalidateQueries({ queryKey: [ACTIVE_STAY_RESOURCE] });
    }, []);

    React.useEffect(() => {
        if (!canSeeMemberships) return undefined;

        subscribe(WebSocketGroup.MEMBERSHIPS, handleWebSocket);

        return () => unsubscribe(WebSocketGroup.MEMBERSHIPS, handleWebSocket);
    }, [canSeeMemberships, handleWebSocket, subscribe, unsubscribe]);

    return null;
}
